import { ROUTE_NAMES } from '@/js/plugins/router/route-names-constants.js'

export default {
  computed: {
    skuRoute() {
      return this.code
        ? {
            name: ROUTE_NAMES.SKU_DETAIL,
            params: {
              sku: this.code,
            },
          }
        : undefined
    },
  },
}
